<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps && instruction.dose) {
		<app-instruction-box>{{ instruction.dose.quantity }} {{ instruction.dose.unit }}</app-instruction-box>
	}
</ng-template>